import { IconButton, Menu, styled, Typography } from "@mui/material";
import { MouseEvent, useEffect, useState } from "react";
import { Calendar, DateObject } from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";
import moment from "jalali-moment";
import CalendarIcon from "assets/icons/CalendarIcon";
import { DateToString } from "components/Reports/DateFilter";
import "./BasicDateInputStyles.css";
import { Close } from "@mui/icons-material";
import { useAppSelector } from "../../store/store";
import { useParams } from "react-router-dom";

const InputWrapper = styled("div")(({ theme }) => ({
  padding: "2px 6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "40px",
  width: "100%",
  border: "1px solid #C2D0E3",
  borderRadius: 6,
  cursor: "pointer"
}));

const InputContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column"
}));

let weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];

export default function BasicDateInput(props: BasicDateInputProps) {
  let { label, isGregorian, required, onChange, defaultValues, styles, range, placeholder, disable } =
    props;
  const store = useAppSelector((state: any) => state);
  const business = store.businessReducer.business?.business;
  isGregorian = business.is_gregorian;
  const { id, type } = useParams();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [calendar, setCalendar] = useState(isGregorian ? gregorian : persian);
  const [locale, setLocale] = useState(isGregorian ? gregorian_en : persian_fa);
  const [calendarActive, setCalendarActive] = useState(false);
  const [firstTimeChange, setFirstTimeChange] = useState(true)
  const [values, setValues] = useState<DateObject[]>();
  const val = values
    ? (values[0] ? values[0].format() : "") + (values[1] ? " - " + values[1].format() : "")
    : placeholder;

  //useEffect(() => {
  //isGregorian ? weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] : weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  // if(isGregorian){
  //   setCalendar(gregorian)
  //   setLocale(gregorian_fa)
  // }else{
  //   setCalendar(persian)
  //   setLocale(persian_fa)
  // }
  //}, []);

  // useEffect(() => {
  //   let d;
  //   console.log(`defaultValues are : ${JSON.stringify(defaultValues)}`);
  //   if (isGregorian)
  //     d = defaultValues && defaultValues.map(
  //       (x) => {
  //         console.log(`x before all if is: ${x}`);
  //         if (isGregorian) {
  //           console.log("hereeeeeeeeeeeeeeeee");
  //           console.log(x);
  //           x = moment.from(x, "fa", "YYYY/MM/DD").locale("en").format("YYYY/MM/DD");
  //           console.log(x);
  //         }
  //         return new DateObject({ calendar: calendar, date: x, format: "YYYY/MM/DD", locale: locale });
  //       }
  //     );
  //   if (d) setValues(d);
  //   setCalendarActive(true);
  // }, [defaultValues]);
  useEffect(() => {
    const d =
      defaultValues &&
      defaultValues.map(
        (x) => {
          if (isGregorian) {
            if (id) {
              if (firstTimeChange) {
                x = moment.from(x, "en", "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD")
                setFirstTimeChange(false)
              } else {
                let shouldConvertDate = parseInt(x.slice(0, 4)) < 1970
                if (shouldConvertDate) x = moment.from(x, "fa", "YYYY/MM/DD").locale("en").format("YYYY/MM/DD")
              }
            } else {
              if (firstTimeChange) {
                x = moment().locale("en").format("YYYY/MM/DD")
                setFirstTimeChange(false)
              } else {
                x = moment.from(x, "en", "YYYY/MM/DD").locale("en").format("YYYY/MM/DD")
              }
            }
          }
          return new DateObject({ calendar: calendar, date: x, format: "YYYY/MM/DD", locale: locale })
        });
    if (d) setValues(d);
  }, [defaultValues]);

  const handleClose = () => setAnchorEl(null);

  function handleClick(event: MouseEvent<HTMLElement>) {
    !disable && setAnchorEl(event.currentTarget);
  }

  function handleChange(date: DateObject) {
    setValues([date]);
    onChange && onChange(isGregorian ? [date.format("YYYY/MM/DD")] : [DateToString(date.toDate())]);
    handleClose();
  }

  function handleRangeChange(dates: DateObject[]) {
    if (dates.length === 2) {
      setValues(dates);
      onChange && onChange(dates.map((date) => {
        if (isGregorian) {
          return date.format("YYYY/MM/DD")
        }
        return DateToString(date.toDate())

      }));
      handleClose();
    }
  }

  function handleClear(e: MouseEvent) {
    e.stopPropagation();
    setValues(undefined);
    onChange && onChange();
  }

  return (
    <InputContainer style={{ ...(styles ? styles.container : {}) }}>
      {label && (
        <div style={{ fontSize: 14, fontWeight: 400, padding: "0px 8px 12px 0px", color: "#33383D" }}>
          {label}
          {required ? "*" : ""}
        </div>
      )}
      <InputWrapper
        style={{ ...(styles ? styles.inputWrapper : {}), ...(disable && { backgroundColor: "#f2f5fc" }) }}
        onClick={handleClick}
      >
        {!!props.customView ? (
          props.customView(values)
        ) : (
          <>
            <div style={{ display: "flex", gap: 12 }}>
              <CalendarIcon />
              <Typography variant="body2">
                <span>{val}</span>
              </Typography>
            </div>
            <div>
              {values && !props.withoutClear && (
                <IconButton onClick={handleClear}>
                  <Close fontSize="small" />
                </IconButton>
              )}
            </div>
          </>
        )}
      </InputWrapper>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        sx={{ "& div": { "& ul": { paddingTop: 0, paddingBottom: 0 } } }}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        disableScrollLock
      >
        {range ? (
          <Calendar
            className="custom-calendar"
            //weekDays={weekDays}
            value={values}
            calendar={isGregorian ? gregorian : persian}
            locale={isGregorian ? gregorian_en : persian_fa}
            range
            onChange={handleRangeChange}
          />
        ) : (
          <Calendar
            className="custom-calendar"
            //weekDays={weekDays}
            value={values && values[0]}
            calendar={isGregorian ? gregorian : persian}
            locale={isGregorian ? gregorian_en : persian_fa}
            onChange={handleChange}
          />
        )}
      </Menu>
    </InputContainer>
  );
}
